import { ReactTFC } from "../../../utils/fp/missing-ts-parts";
import React from "react";

import { css } from "@emotion/react";

import { ReactComponent as RemoveRoundSvg } from "../../../assets/icons/close-round.svg";
import { CSS_COLORS } from "../../../styles/styles-css-variables";
import { CarouselTip } from "./CarouselTip";
import { CSS_MQ } from "../../../styles/breakpoints";

import { fontColor, FONTS, fontSize } from "../../../styles/fonts";
import { UpArrowSvg } from "../../../assets";

export const ProductSelectDropdown: ReactTFC<{
  hasActiveCarousel: boolean;
  label: string;
  onEditRequested: () => void;
  onRemoveRequested: (() => void) | undefined;
}> = props => {
  const canRemoveElements = typeof props.onRemoveRequested !== "undefined";

  return (
    <div
      css={css`
        position: relative;
      `}
    >
      <UpArrowSvg
        className={props.hasActiveCarousel ? "opened" : undefined}
        css={css`
          position: absolute;
          right: 16px;
          top: calc(50% - 5px);

          width: 12px;
          height: 8px;
          ${CSS_MQ.atLeastMd} {
            width: 16px;
            height: 10px;
          }

          color: black;

          transition: transform 0.1s linear;
          &.opened {
            transform: rotate(180deg);
          }
        `}
      />
      {props.hasActiveCarousel && <CarouselTip />}

      {canRemoveElements && (
        <button
          css={css`
            display: block;

            position: absolute;
            z-index: 2;

            left: -12px;
            top: -12px;

            &[disabled] {
              color: ${CSS_COLORS.Grey5};
            }
          `}
          onClick={props.onRemoveRequested}
        >
          <RemoveRoundSvg />
        </button>
      )}

      <button
        name="products"
        onClick={() => props.onEditRequested()}
        css={[
          FONTS.SwarovskiFutura500,
          fontColor.black,
          fontSize.x2,
          css`
            height: 60px;
            ${CSS_MQ.atLeastMd} {
              height: 80px;
            }
            width: 100%;

            padding: 0 20px 0 12px;
            ${CSS_MQ.atLeastMd} {
              padding: 0 20px;
            }

            border: 1px solid ${CSS_COLORS.Grey5};
            border-radius: 8px;

            -moz-appearance: none;
            -webkit-appearance: none;
            appearance: none;

            position: relative;
          `,
        ]}
      >
        {props.label}
      </button>
    </div>
  );
};
